export default "__VITE_ASSET__c1d3d67a__"